export type ClassName	= string|boolean|undefined|null;

export namespace Dom {
	export const classes	= (...names:ReadonlyArray<ClassName>):string =>
		names.filter(it =>
			it !== false	&&
			it !== true		&&
			it !== null		&&
			it !== undefined
		).join(" ");
}
